import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from './mobileMessagesActions';
import { LoadingBlueLarge } from 'merchant-portal-components';
import MobileMessageDetailsContainer from './MobileMessageDetails/MobileMessageDetailsContainer';
import MobileMessagesListContainer from './MobileMessagesList/MobileMessageListContainer';
import { getProducts } from '../../../MenuManagement/Products/productsActions';
import { getCombos } from '../../../MenuManagement/CombosManager/combosAction';
const OneTimeMobileMessageContainer = (props) => {
  useEffect(() => {
    props.getProducts({
      page_number: 1,
      page_size: '4000',
      sorting_option: 'title-asc',
      search_string: '',
      has_next_page: true,
    });
    props.fetchMobileMessages();
    props.getCombos({
      page_number: 1,
      page_size: '2000',
      sorting_option: 'title-asc',
      search_string: '',
      has_next_page: false,
    });
  }, []);
  if (
    props.allOffers &&
    // props.allOffers.length > 0 &&
    props.allProducts &&
    props.allCombos &&
    // props.allProducts.length > 0 &&
    props.allSegments &&
    // props.allSegments.length > 0 &&
    props.mobileMessagesReducer.response &&
    props.appIdentifier
  ) {
    const { mobileMessagesReducer } = props;
    const {
      isEditOnlyMobileMessage,
      isReadOnlyMobileMessage,
      isCreateOnlyMobileMessage,
    } = mobileMessagesReducer;

    if (
      isEditOnlyMobileMessage ||
      isReadOnlyMobileMessage ||
      isCreateOnlyMobileMessage
    ) {
      console.log('allCombos[0])', props.allCombos);
      return <MobileMessageDetailsContainer {...props} />;
    } else {
      return <MobileMessagesListContainer {...props} />;
    }
  } else {
    return <LoadingBlueLarge height='80vh' />;
  }
};

const mapStateToProps = (state) => {
  return {
    mobileMessagesReducer: state.mobileMessagesReducer,
    allProducts: state.productsReducer.allProducts,
    allSegments: state.segments.availableSegments,
    allOffers: state.OfferEngineReducer.allOffersEngine,
    allCombos: state.combosReducer.allInitialCombos,
    appIdentifier: state.accountReducer.appIdentifier,
  };
};

export default connect(mapStateToProps, { ...actions, getProducts, getCombos })(
  OneTimeMobileMessageContainer
);
